import React, { Component } from "react";
import { connect } from "react-redux";
import { default as ReactSelect } from "react-select";
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import { isDesktop } from "react-device-detect";
import Modal from "react-modal";

import DataTable from "../../components/Datatable/DataTable";
import Button from "../../components/Button/Button";
import { formValidation, clearFormValidation } from "../../hoc/Shared/utility";
import StringInput from "../../components/Input/StringInput/StringInput";

import MobileCryptoDetails from "./MobileCryptoDetails";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

import { addWithdrawalCryptoAddress, getDropDown } from "../../store/ducks/withdrawal/actions";
import { getAgentCryptoAddress, removeAgentCryptoAddress, updateAgentCryptoAddress } from "../../store/ducks/profile/actions";

let cryptoChannel = [
    { id: 0, label: "TRC20-USDT", type: "usdt" },
    { id: 1, label: "TRC20-USDC", type: "usdc" },
];
class CryptoDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            agentCryptoAddressData: [],
            cryptoSelect: [],
            crypto: "",
            network: "",
            withdrawalAddress: "",
            totalRecords: 0,
            error_message: [],
            touched: false,

            edit_id: null,
            edit_crypto: "",
            edit_network: "",
            edit_withdrawal_address: "",
            openModal: false,
        };
    }

    componentDidMount() {
        formValidation("add_crypto_address_form");

        this.props.getDropDown();
        this.props.getAgentCryptoAddress();
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextProps.agent_crypto_address_data !== this.props.agent_crypto_address_data && nextProps.agent_crypto_address_data !== undefined) {
            if (nextProps.agent_crypto_address_data.responseCode === 200) {
                this.setState({
                    agentCryptoAddressData: nextProps.agent_crypto_address_data.data,
                    loading: false,
                    totalRecords: nextProps.agent_crypto_address_data.data.length,
                });

                Swal.close();
            }
        }

        if (nextProps.agent_remove_crypto_address_result !== this.props.agent_remove_crypto_address_result) {
            if (nextProps.agent_remove_crypto_address_result.responseCode === 200) {
                const { t } = this.props;
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    title: t("global.success"),
                    html: t("crypto-address-details.crypto-acc-delete-successful"),
                    icon: "success",
                    confirmButtonText: t("global.confirm"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then((result) => {
                    this.props.getAgentCryptoAddress();
                });
            } else if (nextProps.agent_remove_crypto_address_result.responseCode === 422) {
                this.setState({
                    touched: true,
                    error_message: nextProps.agent_remove_crypto_address_result.message,
                });
                Swal.close();
            } else {
                return false;
            }
        }

        if (nextProps.agent_update_crypto_address_result !== this.props.agent_update_crypto_address_result) {
            if (nextProps.agent_update_crypto_address_result.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    html: t("crypto-address-details.crypto-acc-edit-successful"),
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop ? {
                        container: "swal-mobile-container sucess",
                        icon: "swal-success-icon",
                    } : []
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({
                            openModal: false,
                            edit_id: null,
                            edit_bank_key: null,
                            edit_crypto: "",
                            edit_network: "",
                            edit_withdrawal_address: "",
                            touched: false,
                            error_message: [],
                            formError: false
                        });
                        this.searchHandler();
                    }
                });
            } else {
                clearFormValidation("update_member_withdrawal_address_form");
                if (nextProps.agent_update_crypto_address_result.responseCode === 422) {
                    this.setState({
                        error_message: nextProps.agent_update_crypto_address_result.message.input_error || [],
                        formError: true,
                    });
                    Swal.close();
                } else {
                    let msg = null;
                    msg = "<ul>";
                    nextProps.agent_update_crypto_address_result.message.forEach((val) => {
                        msg += "<li>" + val + "</li>";
                    });
                    msg += "</ul>";

                    Swal.fire({
                        iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                        icon: "error",
                        title: t("global.sorry"),
                        html: msg,
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                        customClass: !isDesktop ? {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        } : [],
                    });
                }
            }
        }

        if (nextProps.store_withdrawal_crypto_address !== this.props.store_withdrawal_crypto_address) {
            const { t } = this.props;
            if (nextProps.store_withdrawal_crypto_address.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    title: t("global.success"),
                    html: t("crypto-address-details.crypto-acc-add-successful"),
                    icon: "success",
                    confirmButtonText: t("global.confirm"),
                    customClass: !isDesktop ? {
                        container: "swal-mobile-container sucess",
                        icon: "swal-success-icon",
                    } : []
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({
                            cryptoSelect: [],
                            crypto: "",
                            withdrawalAddress: "",
                            loading: false,
                            touched: false,
                            error_message: [],
                            formError: false,
                            showAddBank: false
                        });

                        this.props.getAgentCryptoAddress();
                    }
                });
            } else if (nextProps.store_withdrawal_crypto_address.responseCode === 422) {
                this.setState({
                    touched: true,
                    formError: true,
                    error_message: nextProps.store_withdrawal_crypto_address.message,
                });
                Swal.close();
            } else {
                return false;
            }
        }

        // if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined) {
        //     if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === "success") {
        //         if (cryptoChannel.length === 0) {
        //             nextProps.dropDown.data.payment_gateway &&
        //                 nextProps.dropDown.data.payment_gateway
        //                     .filter((val) => val.slug_details !== "crypto-vendor" && val.transaction_slug === "crypto" && val.dp_status === 1)
        //                     .map((val) => {
        //                         cryptoChannel.push({
        //                             id: val.id,
        //                             label: val.slug,
        //                             type: val.slug_details.toString().toLowerCase(),
        //                         });
        //                     });
        //         }
        //     }
        // }
        return true;
    }

    toggleAddBank = () => {
        this.setState({ showAddBank: !this.state.showAddBank });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    actionFormatter = (cell, row) => {
        let removeButton, output;

        removeButton = (
            <>
                <Button
                    typeButton="button"
                    classValue="btn icon"
                    key={`edit-${row.withdrawalAddressId}`}
                    idValue={row.withdrawalAddressId === undefined ? 0 : row.withdrawalAddressId}
                    clicked={(e) => this.openModalHandler(e, row.withdrawalAddressId, row.network, row.withdrawalAddress)}
                    buttonName={<Icon icon="uil:edit" />}
                />
                <Button
                    typeButton="button"
                    classValue="btn icon red"
                    key={`remove-${row.withdrawalAddressId}`}
                    idValue={row.withdrawalAddressId === undefined ? 0 : row.withdrawalAddressId}
                    clicked={(e) => this.removeCryptoAddressHandler(e, row.withdrawalAddressId, row.withdrawalAddress)}
                    buttonName={<Icon icon="uil:trash-alt" />}
                />
            </>
        );

        output = [removeButton];
        return output;
    };

    addCryptoWithdrawalAddressHandler = (event) => {
        event.preventDefault();
        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.crypto = this.state.crypto.toUpperCase();
                data.network = this.state.network;
                data.withdrawal_address = this.state.withdrawalAddress;

                this.props.addWithdrawalCryptoAddress(data);
            }
        });
    };

    removeCryptoAddressHandler = (e, id, withdrawalAddress) => {
        e.preventDefault();
        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : "",
            title: t("global.reminder"),
            text: t("global.remove") + " " + withdrawalAddress + "? " + t("global.deleted-cannot-recovered") + ".",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.confirm"),
            cancelButtonText: t("global.cancel"),
            customClass: !isDesktop ? {
                container: "swal-mobile-container reminder",
                icon: "swal-reminder-icon",
            } : []
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.withdrawal_address_id = id;
                this.props.removeAgentCryptoAddress(data);
            }
        });
    };

    handleNetworkChange = (event) => {
        this.setState({
            network: event.label,
            crypto: event.type,
        });
    };

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    openModalHandler = (e, id, network, withdrawal_address) => {
        e.preventDefault();

        this.setState({
            openModal: true,
            edit_id: id,
            edit_network: network,
            edit_withdrawal_address: withdrawal_address,
            error_message: [],
            formError: false
        });
    };

    closeModalHandler = (e) => {
        e.preventDefault();

        this.setState({
            openModal: false,
        });
    };

    onInputChangeHandler = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            error_message: [],
            formError: false,
        });
    };

    updateWithdrawalAddresssHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.id = this.state.edit_id;
                data.crypto = this.state.edit_network === "TRC20-USDC" ? "USDC" : "USDT";
                data.withdrawal_address = this.state.edit_withdrawal_address;

                this.props.updateAgentCryptoAddress(data);
            }
        });
    };

    searchHandler = () => {
        this.setState({
            loading: true,
        });
        this.props.getAgentCryptoAddress();
    };

    render() {
        const { t } = this.props;
        const cryptoImg = this.imageImport(require.context("../../assets/images/deposit/crypto/", false, /\.(png|jpe?g|svg)$/));
        const columns = [
            { text: t("crypto-address-details.crypto"), dataField: "crypto" },
            { text: t("crypto-address-details.network"), dataField: "network" },
            { text: t("crypto-address-details.withdrawal-address"), dataField: "withdrawalAddress" },
            { text: "", dataField: "delete", formatter: this.actionFormatter },
        ];

        let rsData = [];
        if (this.state.agentCryptoAddressData && !this.state.loading) {
            let cryptoVal = null;
            let cryptoDisplayImage = null;

            rsData = this.state.agentCryptoAddressData.map((val, idx) => {
                if (val.crypto === "USDT") {
                    cryptoDisplayImage = "usdt";
                } else if (val.crypto === "USDC") {
                    cryptoDisplayImage = "usdc";
                }

                cryptoVal = isDesktop ? (
                    <div className="d-flex align-items-center" key={idx}>
                        <img className="me-3" src={cryptoImg[`${cryptoDisplayImage}.svg`]} alt={val.network.toUpperCase()} />
                        <p>{val.crypto}</p>
                    </div>
                ) : (
                    <div className="my-bd-m-col" key={idx}>
                        <img src={cryptoImg[`${cryptoDisplayImage}.svg`]} alt={val.network.toUpperCase()} />
                        <div className="my-bd-m-acc">
                            <p>{val.network}</p>
                            <p>{val.withdrawal_address}</p>
                        </div>
                    </div>
                );

                return {
                    no: idx,
                    crypto: cryptoVal,
                    network: val.network,
                    withdrawalAddress: val.withdrawal_address,
                    withdrawalAddressId: val.id,
                };
            });
        }

        if (this.state.openModal) {
            formValidation("update_member_withdrawal_address_form");
        }

        return (
            <Auxiliary>
                {isDesktop ? (
                    <>
                        <Modal
                            isOpen={this.state.openModal}
                            closeTimeoutMS={500}
                            portalClassName={`global-modal`}
                            className="modal-dialog modal-dialog-centered modal-pd"
                            ariaHideApp={false}
                            onRequestClose={(event) => this.closeModalHandler(event)}
                        >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{t("crypto-address-details.edit-withdrawal-address-details")}</h5>
                                    <Icon type="button" className="btn-close" icon="mdi:close" onClick={(event) => this.closeModalHandler(event)} />
                                </div>
                                <div className="modal-body">
                                    <form
                                        className="forms-col"
                                        method="post"
                                        id="update_member_withdrawal_address_form"
                                        encType="multipart/form-data"
                                        onSubmit={this.updateWithdrawalAddresssHandler}
                                        noValidate
                                    >
                                        <div>
                                            <label className="col-form-label lh-1">{t("crypto-address-details.withdrawal-address")}</label>
                                            <StringInput
                                                id="edit_withdrawal_address"
                                                name="edit_withdrawal_address"
                                                className={`form-control ${this.state.error_message.withdrawal_address ? "was-validated is-invalid" : ""}`}
                                                value={this.state.edit_withdrawal_address}
                                                onChange={(event) => this.onInputChangeHandler(event)}
                                                step="any"
                                                required={true}
                                                requiredMessage={t("validation.required")}
                                                formError={this.state.formError}
                                                errorMsg={this.state.error_message.withdrawal_address || ""}
                                            />
                                        </div>
                                        <Button typeButton="submit" classValue="btn btn-gradient-blue mt-3" buttonName={t("top-profile.update")} />
                                    </form>
                                </div>
                            </div>
                        </Modal>

                        <div className="tab-pane fade show active" id="crypto-details" role="tabpanel" aria-labelledby="crypto-tab">
                            <DataTable
                                keyField="no"
                                data={rsData}
                                columns={columns}
                                activePage={1}
                                limit={20}
                                totalItems={this.state.totalRecords}
                                paginationHandler={(val) => this.datatablesChangeHandler(val, "activePage")}
                                sizePerPageHandler={(val) => this.datatablesChangeHandler(val, "limit")}
                                loading={this.state.loading}
                                hideSearchBar={true}
                                hidePagination={true}
                                hideTotalRecords={true}
                                classValue="pd-table w-border mb-0"
                                component="crypto-details"
                            />
                            <form method="post" id="add_crypto_address_form" className="form-horizontal" onSubmit={this.addCryptoWithdrawalAddressHandler} noValidate>
                                {this.state.loading ? (
                                    <Skeleton count={4} style={{ marginBottom: "1rem" }} height={50} />
                                ) : (
                                    <>
                                        <button onClick={() => this.toggleAddBank()} className="btn text-icon mt-5 mb-3" type="button">
                                            {this.state.showAddBank ? <Icon icon="uil:minus-circle" /> : <Icon icon="uil:plus-circle" />}
                                            {t("crypto-address-details.add-new-crypto-acc")}
                                        </button>
                                        {this.state.showAddBank &&
                                        <div className='add-more-col'>
                                            <div className="add-more-headers mb-3">
                                                <div className="row">
                                                    <label className="col-3 offset-3">{t("crypto-address-details.network")}</label>
                                                    <label className="col-6">{t("crypto-address-details.withdrawal-address")}</label>
                                                </div>
                                            </div>
                                            <div className="row g-2">
                                                <div className="col-6">
                                                    <ReactSelect
                                                        classNamePrefix="react-select"
                                                        name="network"
                                                        options={cryptoChannel}
                                                        placeholder={t("crypto-address-details.select-network")}
                                                        onChange={this.handleNetworkChange}
                                                        formatOptionLabel={(item) => (
                                                            <>
                                                                <img src={cryptoImg[`${item.type}.svg`]} alt={item.label} />
                                                                <p>{item.label}</p>
                                                            </>
                                                        )}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <div className="d-flex">
                                                        <div className="w-100 me-2">
                                                            <StringInput
                                                                id="withdrawalAddress"
                                                                name="withdrawalAddress"
                                                                className={`form-control ${this.state.error_message.withdrawal_address ? "was-validated is-invalid" : ""}`}
                                                                value={this.state.withdrawalAddress}
                                                                onChange={this.handleChange}
                                                                required={true}
                                                                requiredMessage={t("validation.required")}
                                                                formError={this.state.formError}
                                                                errorMsg={this.state.error_message.withdrawal_address || ""}
                                                            />
                                                        </div>
                                                        <Button
                                                            typeButton="submit"
                                                            classValue="btn btn-gradient-blue"
                                                            idValue="submit"
                                                            buttonName={t("crypto-address-details.add-withdrawal-address")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </>
                                )}
                            </form>
                        </div>
                    </>
                ) : (
                    <MobileCryptoDetails
                        {...this.state}
                        rsData={rsData}
                        columns={columns}
                        datatablesChangeHandler={this.datatablesChangeHandler}
                        actionFormatter={this.actionFormatter}
                        removeCryptoAddressHandler={this.removeCryptoAddressHandler}
                        searchHandler={this.searchHandler}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dropDown: state.withdrawal.dropDown,
        agent_crypto_address_data: state.profile.agent_crypto_address_data,
        store_withdrawal_crypto_address: state.withdrawal.store_withdrawal_crypto_address,
        agent_update_crypto_address_result: state.profile.agent_update_crypto_address_result,
        agent_remove_crypto_address_result: state.profile.agent_remove_crypto_address_result
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDropDown: (data) => dispatch(getDropDown(data)),
        getAgentCryptoAddress: () => dispatch(getAgentCryptoAddress()),
        addWithdrawalCryptoAddress: (data) => dispatch(addWithdrawalCryptoAddress(data)),
        updateAgentCryptoAddress: (data) => dispatch(updateAgentCryptoAddress(data)),
        removeAgentCryptoAddress: (data) => dispatch(removeAgentCryptoAddress(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(CryptoDetails));
